import ReactGA from 'react-ga4';

export const GA_TRACKING_ID = 'G-Y7FCKS5Q4K';

// Track only real visitors on production builds. navigator.webdriver is true
// in the headless browser used by scripts/prerender.js; skipping it keeps
// gtag.js out of the prerendered HTML and fake pageviews out of GA.
export const analyticsEnabled = () =>
  process.env.NODE_ENV === 'production' &&
  typeof navigator !== 'undefined' &&
  !navigator.webdriver;

export const trackEvent = (name, params = {}) => {
  if (!analyticsEnabled() || !ReactGA.isInitialized) return;
  ReactGA.event(name, params);
};

// GA4 recommended lead event; mark `generate_lead` as a key event in GA4.
export const trackLead = (formName) => trackEvent('generate_lead', { form_name: formName });
